export const formatLogo = (name, extension = "png") => {
  if (name) {
    return name.toLowerCase().replace(/\s/g, "_") + `.${extension}`;
  }
};

export default formatLogo;
